__turbopack_context__.v({
  "container": "TechStackSection-module-scss-module__01Zfra__container",
  "description": "TechStackSection-module-scss-module__01Zfra__description",
  "title": "TechStackSection-module-scss-module__01Zfra__title",
});
